import { useEffect, useRef, useState } from 'react';

const useDynamicMargins = (itemCount: number) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [itemWidths, setItemWidths] = useState<number[]>([]);
  const [totalWidth, setTotalWidth] = useState(0);
  const [margin, setMargin] = useState(4);

  const updateItemWidth = (index: number, width: number) => {
    setItemWidths((prevWidths) => {
      const newWidths = [...prevWidths];
      newWidths[index] = width;
      return newWidths;
    });
  };

  useEffect(() => {
    if (itemWidths.length === itemCount) {
      const calculatedTotalWidth = itemWidths.reduce(
        (sum, width) => sum + width,
        0,
      );
      setTotalWidth(calculatedTotalWidth);
    }
  }, [itemWidths, itemCount]);

  useEffect(() => {
    if (containerRef.current && totalWidth > 0) {
      const containerWidth = containerRef.current.offsetWidth;
      const remainingSpace = containerWidth - totalWidth;
      const calculatedMargin = remainingSpace / (itemCount - 1);
      setMargin(Math.min(Math.max(calculatedMargin, 4), 12));
    }
  }, [totalWidth, itemCount]);

  return {
    containerRef,
    itemWidths,
    setItemWidths: updateItemWidth,
    margin,
  };
};

export default useDynamicMargins;
